"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelatedElementsSection = void 0;
var react_1 = __importDefault(require("react"));
var RELATION_LABEL = {
    'persona.feels.painPoint': 'feels pain',
    'persona.uses.tech': 'uses tech',
    'persona.measuredBy.metric': 'measured by',
    'tech.dependsOn.tech': 'depends on',
    'tech.exposes.risk': 'exposes risk',
    'risk.mitigatedBy.tech': 'mitigated by',
    'benefit.resolves.painPoint': 'resolves',
    'benefit.measuredBy.metric': 'measured by',
    'metric.tracks.benefit': 'tracks',
    'roadmap.dependsOn.roadmap': 'depends on',
    'budget.fundedBy.budget': 'funded by',
};
var TYPE_ICON = {
    persona: 'Contact',
    pain: 'StatusErrorFull',
    benefit: 'CheckMark',
    metric: 'BarChartVertical',
    risk: 'Warning',
    tech: 'Server',
    data: 'Database',
    integration: 'PlugConnected',
    budget: 'Money',
    roadmap: 'TimelineProgress',
};
/**
 * Renders cross-element links derived from co-occurrence in the
 * same use case (persona ↔ pain, tech ↔ risk, benefit ↔ metric…).
 * Hidden when the backend has no relations for the element yet.
 */
exports.RelatedElementsSection = function (_a) {
    var related = _a.related;
    if (!related || related.length === 0)
        return null;
    return (react_1.default.createElement("section", { className: "ws-entity-popup-section", "data-section-id": "related" },
        react_1.default.createElement("h4", { className: "ws-entity-popup-section-title" }, "Related elements"),
        react_1.default.createElement("div", { className: "ws-entity-popup-list" }, related.map(function (row) {
            var _a, _b;
            return (react_1.default.createElement("div", { key: row.elementId + row.relationType, className: "ws-entity-popup-list-item" },
                react_1.default.createElement("div", { className: "ws-entity-popup-list-item-main" },
                    react_1.default.createElement("i", { className: 'ms-Icon ms-Icon--' + ((_a = TYPE_ICON[row.type]) !== null && _a !== void 0 ? _a : 'Tag'), "aria-hidden": "true", style: { color: '#6b7280' } }),
                    react_1.default.createElement("div", { className: "ws-entity-popup-list-item-text" },
                        react_1.default.createElement("span", { className: "ws-entity-popup-list-item-title" }, row.canonicalName),
                        react_1.default.createElement("span", { className: "ws-entity-popup-list-item-subtitle" },
                            row.inbound ? '← ' : '→ ', (_b = RELATION_LABEL[row.relationType]) !== null && _b !== void 0 ? _b : row.relationType))),
                react_1.default.createElement("span", { className: "ws-entity-popup-list-item-meta" },
                    "\u00D7",
                    row.weight)));
        }))));
};
